import { render, staticRenderFns } from "./Content.vue?vue&type=template&id=3677da7e&scoped=true&"
import script from "./Content.vue?vue&type=script&lang=js&"
export * from "./Content.vue?vue&type=script&lang=js&"
import style0 from "./Content.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Content.vue?vue&type=style&index=1&id=3677da7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3677da7e",
  null
  
)

export default component.exports